// Convert emoji data from unicode string
const convertEmoji = (reward) =>
  reward?.['emoji'] && String.fromCodePoint(parseInt(reward?.emoji, 16))

export default convertEmoji
